// extracted by mini-css-extract-plugin
export default {"ch-custom-sidebar":"checkout-customization-sidebar_ch-custom-sidebar__v+daf","ch-custom-sidebar__main":"checkout-customization-sidebar_ch-custom-sidebar__main__l5N37"};